import { DataThemes, RowBackgroundColours } from '@api';

export const themes: Record<DataThemes, string> = {
  [DataThemes._0]: '',
  [DataThemes._1]: 'mango-tango',
  [DataThemes._2]: 'summer-sky',
  [DataThemes._3]: 'navy-blue',
};

export const rowBgColors: Record<RowBackgroundColours, string> = {
  [RowBackgroundColours._0]: '',
  [RowBackgroundColours._1]: 'bg-blue',
};

export const bgColors: Record<number, string> = {
  [0]: '',
  [1]: 'white',
  [2]: 'grey',
};
